module.exports = __webpack_public_path__ + "static/img/KingsArts-icon-180.a8a4a5c2.png";